import InnerNavbar from '../../components/feature/InnerNavbar';
import InnerFooter from '../../components/feature/InnerFooter';
import ServicesHero from './components/ServicesHero';
import ServiceCards from './components/ServiceCards';
import MovingProcess from './components/MovingProcess';
import ServicesWhyUs from './components/ServicesWhyUs';
import ServicesFAQ from './components/ServicesFAQ';
import TrustBar from '../home/components/TrustBar';
import Testimonials from '../home/components/Testimonials';
import QuoteForm from '../home/components/QuoteForm';
import { Link } from 'react-router-dom';

const stats = [
  { icon: 'ri-award-line', value: '20+', label: 'Years Experience', color: 'text-orange-400' },
  { icon: 'ri-star-fill', value: '4.6★', label: '10+ Google Reviews', color: 'text-amber-400' },
  { icon: 'ri-shield-check-line', value: '100%', label: 'Licensed & Insured', color: 'text-emerald-400' },
  { icon: 'ri-group-line', value: '5,000+', label: 'Successful Moves', color: 'text-sky-400' },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <InnerNavbar activePage="services" />

      {/* 2 — Hero */}
      <ServicesHero />

      {/* 3 — TrustBar */}
      <TrustBar />

      {/* 4 — Services */}
      <ServiceCards />

      {/* 5 — WhyChooseUs */}
      <ServicesWhyUs />

      {/* 6 — About (Trust Stats Band) */}
      <section className="py-14 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {stats.map((stat) => (
              <div key={stat.label} className="text-white">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-3xl ${stat.color}`}></i>
                </div>
                <div className={`text-3xl font-black mb-1 ${stat.color}`}>{stat.value}</div>
                <div className="text-slate-400 text-sm font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7 — Process */}
      <MovingProcess />

      {/* 8 — ServiceArea */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-slate-50 rounded-3xl p-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="max-w-xl">
              <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold px-3 py-1.5 rounded-full mb-3">
                Service Area
              </span>
              <h2 className="text-2xl font-black text-slate-900 mb-3">
                We Come to You — Across All of Southern California
              </h2>
              <p className="text-slate-600 text-sm leading-relaxed">
                Our moving services are available throughout Orange County, the Coachella Valley, Long Beach, and the greater LA area. We have three local offices and crews ready to serve your neighborhood.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-end">
              {['Orange County', 'Coachella Valley', 'Long Beach', 'Palm Springs', 'Irvine', 'Newport Beach', 'Indio', 'Anaheim', '+ More'].map((city) => (
                <span key={city} className="bg-white border border-gray-200 text-slate-700 text-sm font-semibold px-4 py-2 rounded-full hover:border-orange-300 hover:text-orange-600 transition-colors">
                  <i className="ri-map-pin-line mr-1 text-orange-400"></i>{city}
                </span>
              ))}
            </div>
          </div>
          <div className="text-center mt-8">
            <Link to="/locations"
              className="inline-flex items-center gap-2 border border-orange-300 text-orange-600 px-7 py-3 rounded-xl font-bold hover:bg-orange-50 transition-all whitespace-nowrap">
              <i className="ri-map-2-line"></i>View All Service Locations
            </Link>
          </div>
        </div>
      </section>

      {/* 9 — Testimonials */}
      <Testimonials />

      {/* 10 — FAQ */}
      <ServicesFAQ />

      {/* 11 — QuoteForm */}
      <QuoteForm />

      <InnerFooter />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-6 left-6 z-50 lg:hidden">
        <a
          href="tel:7606257767"
          className="flex items-center gap-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-4 rounded-2xl shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 group"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl">
            <i className="ri-phone-fill text-xl"></i>
          </div>
          <div className="text-left">
            <div className="text-xs font-medium opacity-90 whitespace-nowrap">Call Now</div>
            <div className="text-sm font-bold whitespace-nowrap">(760) 625-7767</div>
          </div>
        </a>
      </div>

      {/* Floating Quote Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="#quote-form"
          className="flex items-center justify-center w-16 h-16 bg-slate-900 text-white rounded-full shadow-2xl hover:bg-amber-500 transition-all duration-300 hover:scale-110"
        >
          <i className="ri-file-list-3-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}
